import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import PLAYER_TYPES from 'constants/player-types';
import { StyledButtonsWrapper, StyledFavoriteActionPanel } from './StyledComponents';
import { FavoritePanelConfirmButton, FavoritePanelCancelButton } from './Buttons';
import SpatialNavigationWrapper from '../../navigation/SpatialNavigationWrapper';
import i18n from 'i18n';

const config = {
  enterTo: 'default-element',
  defaultElement: '#CROSS_BUTTON',
};

const SECTION_NAME = 'PLAYER_FAVORITE_ACTIONS';

const FavoriteActionsSection = (props) => {
  const { content, toggleInFavoriteStatus, onClose, defaultSection } = props;

  const leftAction = {
    title: content.favorite
      ? i18n.t('player.favorite.programRemove')
      : i18n.t('player.favorite.programAdd'),
    onEnter: () => {
      onClose();
      toggleInFavoriteStatus({
        type: PLAYER_TYPES.CATCHUP,
        id: content.id,
        channelId: content.channelId,
      });
    },
  };

  const rightAction = {
    title: get(content.channelMetadata, ['favorite'])
      ? i18n.t('player.favorite.channelRemove')
      : i18n.t('player.favorite.channelAdd'),
    onEnter: () => {
      onClose();
      toggleInFavoriteStatus({
        type: PLAYER_TYPES.CHANNEL,
        id: content.channelId,
      });
    },
  };

  // It immitates "defaultSection" functionallity
  useEffect(() => {
    if (!defaultSection) return;
    SpatialNavigationWrapper.focus(`@${SECTION_NAME}`);
    SpatialNavigationWrapper.focus(config.defaultElement);
  }, [defaultSection]);

  if (!content) return null;

  return (
    <StyledButtonsWrapper sectionName={SECTION_NAME} config={config}>
      <StyledFavoriteActionPanel>
        <FavoritePanelConfirmButton title={leftAction.title} onEnter={leftAction.onEnter} />
        <FavoritePanelCancelButton
          hint={i18n.t('common.cancel')}
          onEnter={onClose}
          id="CROSS_BUTTON"
        />
        <FavoritePanelConfirmButton title={rightAction.title} onEnter={rightAction.onEnter} />
      </StyledFavoriteActionPanel>
    </StyledButtonsWrapper>
  );
};

FavoriteActionsSection.defaultProps = {
  leftAction: {},
  rightAction: {},
};

FavoriteActionsSection.propTypes = {
  onClose: PropTypes.func.isRequired,
  toggleInFavoriteStatus: PropTypes.func.isRequired,
  onSectionFocus: PropTypes.func,
};

export default FavoriteActionsSection;
